module.exports = __webpack_public_path__ + "944537334d50411de0d528e27728ed31.png";